import { useLocale } from '@src/i18n/LocaleProvider'
import { formatCartAmount } from '@src/utils/cart.util'
import { cn } from '@src/utils/tailwind'

export function LineItemPrice({
  basePriceCents,
  discountedPriceCents,
  stack,
  showFree,
}: {
  basePriceCents?: number
  discountedPriceCents?: number
  stack?: boolean
  showFree?: boolean
}) {
  const { t } = useLocale('common')
  if (basePriceCents === undefined) return null

  const basePrice = formatCartAmount(basePriceCents, t)

  if (discountedPriceCents === undefined || discountedPriceCents === basePriceCents) {
    return <p className="ml-auto text-right text-body-md font-medium">{basePrice}</p>
  }

  const discountedPrice = formatCartAmount(discountedPriceCents, t)
  const savingsCents = basePriceCents - discountedPriceCents
  const savingsLabel = `${t('saving')} ${formatCartAmount(savingsCents, t)}`

  const shouldShowFree = showFree && discountedPriceCents === 0

  return (
    <div className="flex flex-col">
      <div
        className={cn('flex items-end gap-1 text-body-md font-medium', {
          'flex-col gap-0': stack,
        })}
      >
        <span className="ml-auto text-body-xs text-bodi-gray-disabled line-through">
          {basePrice}
        </span>
        <span
          className={cn('text-bodi-black-text', {
            'text-bodi-green-deep-500 uppercase': shouldShowFree,
          })}
        >
          {shouldShowFree ? t('free') : discountedPrice}
        </span>
      </div>
      <div className="flex w-fit items-center self-end rounded-[4px] bg-[#E2EDEB] px-1 text-[11px] leading-5 font-semibold whitespace-nowrap text-bodi-green-deep-500">
        {savingsLabel}
      </div>
    </div>
  )
}
